import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CommonExcelButton } from '../../../form-components/CommonExcelButton';
import CommonSelect from '../../../form-components/CommonSelect';
import CommonPagination from '../../../form-components/CommonPagination';
import SalesManagGroupedTable from './SalesManagGroupedTable';
import SalesManagFlatTable from './SalesManagFlatTable';
import {
  GROUPED_CONFIGS,
  ALL_CONFIG,
  REFUND_CONFIG,
  OUTSTANDING_CONFIG,
  TRANSFER_CONFIG,
  TAB_TO_GROUPBY,
} from './salesManagTableConfigs';

import {
  TableSection,
  TableToolbar,
  TableTabs,
  TableTab,
  TableToolbarRight,
  TableWrapper,
  TableLoadingOverlay,
} from './SalesManagTab1Styled';

// 테이블 상단 탭. '전체 내역'만 실제 데이터를 보여주고 나머지는 placeholder(시각적 선택만).
const TABLE_TABS = [
  '전체 내역',
  '상품별 내역',
  '상품구분별 내역',
  '종목별 내역',
  '결제수단별 내역',
  '환불 내역',
  '미수금 내역',
  '양수금 내역',
];

const PER_PAGE_OPTIONS = [
  { value: '10', label: '10개씩 보기' },
  { value: '20', label: '20개씩 보기' },
  { value: '30', label: '30개씩 보기' },
  { value: '50', label: '50개씩 보기' },
  { value: '100', label: '100개씩 보기' },
];

const SalesManagDataTable = ({
  payments,
  summary,
  activeTab,
  onTabChange,
  limit,
  onLimitChange,
  page,
  onPageChange,
  onExcel,
  excelLoading,
  tableLoading,
  onNavigateMember,
  onClickCancel,
  onClickDetail,
  onClickRefundReversal,
  onFetchGroupDetail,
  canPaymentDetailEdit,
  canContractEdit,
  allExpansion,
}) => {
  const { t } = useTranslation();

  const content = payments?.content || [];
  const helpers = { t, onNavigateMember, onClickCancel, onClickDetail, onClickRefundReversal, canPaymentDetailEdit, canContractEdit };
  const isGroupTab = !!GROUPED_CONFIGS[activeTab];

  return (
    <TableSection>
      {/* 상단 탭 + 툴바 */}
      <TableToolbar>
        <TableTabs>
          {TABLE_TABS.map(tab => (
            <TableTab key={tab} selected={activeTab === tab} onClick={() => onTabChange(tab)}>
              {tab}
            </TableTab>
          ))}
        </TableTabs>
        <TableToolbarRight>
          <CommonExcelButton onClick={onExcel} disabled={excelLoading || tableLoading}>
            {excelLoading ? t('다운로드 중...') : t('전체 엑셀 다운로드')}
          </CommonExcelButton>
          <CommonSelect
            value={String(limit)}
            onChange={onLimitChange}
            options={PER_PAGE_OPTIONS}
            width={150}
            disabled={tableLoading}
          />
        </TableToolbarRight>
      </TableToolbar>

      {/* 테이블 */}
      <TableWrapper>
        {tableLoading && (
          <TableLoadingOverlay>
            <CircularProgress size={40} />
          </TableLoadingOverlay>
        )}
        {isGroupTab ? (
          <SalesManagGroupedTable
            groups={summary?.groups || []}
            config={GROUPED_CONFIGS[activeTab]}
            groupBy={TAB_TO_GROUPBY[activeTab]}
            onFetchDetail={onFetchGroupDetail}
            helpers={helpers}
          />
        ) : activeTab === '환불 내역' ? (
          <SalesManagFlatTable rows={content} config={REFUND_CONFIG} helpers={helpers} />
        ) : activeTab === '미수금 내역' ? (
          <SalesManagFlatTable rows={content} config={OUTSTANDING_CONFIG} helpers={helpers} />
        ) : activeTab === '양수금 내역' ? (
          <SalesManagFlatTable rows={content} config={TRANSFER_CONFIG} helpers={helpers} />
        ) : (
          // 전체 내역: 상품별 내역과 동일한 PT* 디자인으로 통일(SalesManagFlatTable + ALL_CONFIG).
          // 복합 결제/환불 행은 갈매기로 수납·환불 라인을 펼쳐 본다(#49).
          <SalesManagFlatTable rows={content} config={ALL_CONFIG} helpers={helpers} expansion={allExpansion} />
        )}
      </TableWrapper>

      {/* 그룹 탭은 전체기간 집계(페이징 무의미)라 제외. 전체/환불/미수금은 서버 페이징. */}
      {!isGroupTab && (
        <CommonPagination
          totalElements={payments?.totalElements}
          limit={limit}
          page={page}
          onChange={onPageChange}
          disabled={tableLoading}
        />
      )}
    </TableSection>
  );
};

export default SalesManagDataTable;
